import { Divider, Flex, Text } from '@chakra-ui/react';
import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OutlineCard } from '@morressier/alembic';
import { ISubmissionFile } from '@publishing-engine/domain/models';
import FileViewerButtonText from 'src/components/Submission/FileViewerButtonText';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
import { useSubmissionFields } from 'src/hooks/useSubmissionFields';

const RevisedSubmission = () => {
  const { getFieldState, checkFormFieldValueIsUpdated } =
    useSubmissionFields('submission');
  const { activeRevision, submissionContextId } = useSubmissionData();
  const configs = {
    TitlePage: getFieldState('TitlePage')?.value as ISubmissionFile,
    Manuscript: getFieldState('Manuscript')?.value as ISubmissionFile
  };
  const isTitlePageValueUpadted = checkFormFieldValueIsUpdated('TitlePage');
  const isManuscriptValueUpadted = checkFormFieldValueIsUpdated('Manuscript');

  const hasUpdatedForm =
    isTitlePageValueUpadted ||
    isManuscriptValueUpadted ||
    activeRevision?.authorResponse ||
    activeRevision?.authorResponseAttachments?.length !== 0;

  return (
    hasUpdatedForm && (
      <>
        <Text textStyle="headingGroup" id="Revised Submission">
          Revised Submission
        </Text>

        <Flex gap={4} flexDirection="column">
          <OutlineCard padding={4}>
            <Flex justifyContent="space-between">
              <Flex flexDirection="column" gap={1}>
                <Text textStyle="headingLine">Revised Manuscript</Text>
                <Flex alignItems="center" gap={1} data-cy="manuscript-file">
                  <FontAwesomeIcon fontSize="20px" icon={faFile} />
                  <FileViewerButtonText
                    file={configs.Manuscript}
                    submissionContextId={submissionContextId}
                    textStyle="textBody"
                    flexShrink={1}
                    minW={0}
                    data-cy="button-preview-manuscript"
                    wordBreak={'break-word'}
                    whiteSpace={'normal'}
                    textAlign={'initial'}
                  >
                    {configs.Manuscript.name}
                  </FileViewerButtonText>
                </Flex>
              </Flex>
              {configs?.TitlePage && (
                <Flex flexDirection="column" gap={1}>
                  <Text textStyle="headingLine">Revised Title page</Text>
                  <Flex alignItems="center" gap={1} data-cy="manuscript-file">
                    <FontAwesomeIcon fontSize="20px" icon={faFile} />
                    <FileViewerButtonText
                      file={configs.TitlePage}
                      submissionContextId={submissionContextId}
                      textStyle="textBody"
                      flexShrink={1}
                      minW={0}
                      data-cy="button-preview-title-page"
                      wordBreak={'break-word'}
                      whiteSpace={'normal'}
                      textAlign={'initial'}
                    >
                      {configs.TitlePage.name}
                    </FileViewerButtonText>
                  </Flex>
                </Flex>
              )}
            </Flex>
          </OutlineCard>
          <OutlineCard padding={4}>
            {(activeRevision?.authorResponse ||
              activeRevision?.authorResponseAttachments?.length !== 0) && (
              <>
                <Flex flexDirection={'column'} gap={2}>
                  <Text textStyle="headingItem">Your Response</Text>
                  <Divider />

                  <Flex flexDirection="column" gap={1}>
                    <Text textStyle="headingLine">
                      Response to review comments
                    </Text>
                    <Text textStyle="textBody">
                      {activeRevision?.authorResponse}
                    </Text>
                  </Flex>
                  {activeRevision?.authorResponseAttachments &&
                    activeRevision?.authorResponseAttachments?.length !== 0 && (
                      <Flex flexDirection="column" gap={1}>
                        <Text textStyle="headingLine">Attach file(s)</Text>
                        {activeRevision?.authorResponseAttachments.map(item => (
                          <Flex
                            alignItems="center"
                            gap={1}
                            data-cy="manuscript-file"
                          >
                            <FontAwesomeIcon fontSize="20px" icon={faFile} />
                            <FileViewerButtonText
                              file={item}
                              submissionContextId={submissionContextId}
                              textStyle="textBody"
                              flexShrink={1}
                              minW={0}
                              data-cy="button-preview-title-page"
                              wordBreak={'break-word'}
                              whiteSpace={'normal'}
                              textAlign={'initial'}
                            >
                              {item.name}
                            </FileViewerButtonText>
                          </Flex>
                        ))}
                      </Flex>
                    )}
                </Flex>
              </>
            )}
          </OutlineCard>
        </Flex>
      </>
    )
  );
};
export default RevisedSubmission;
